const topics = [
  { label: '暑期档影视', heat: '🔥 128万讨论', color: 'bg-primary-100 text-primary-700' },
  { label: '网红翻车事件', heat: '🔥 95万讨论', color: 'bg-accent-100 text-accent-700' },
  { label: 'AI新品发布', heat: '76万讨论', color: 'bg-secondary-100 text-secondary-700' },
  { label: '电竞世界赛', heat: '62万讨论', color: 'bg-primary-100 text-primary-700' },
  { label: '明星恋情实锤', heat: '🔥 110万讨论', color: 'bg-accent-100 text-accent-700' },
  { label: '综艺名场面', heat: '88万讨论', color: 'bg-secondary-100 text-secondary-700' },
  { label: '社会民生热点', heat: '🔥 105万讨论', color: 'bg-primary-100 text-primary-700' },
  { label: '财经大事件', heat: '54万讨论', color: 'bg-accent-100 text-accent-700' },
  { label: '汽车圈大瓜', heat: '41万讨论', color: 'bg-secondary-100 text-secondary-700' },
  { label: '美食探店踩雷', heat: '36万讨论', color: 'bg-primary-100 text-primary-700' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 lg:px-8 max-w-[1280px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 text-center mb-3">
          热门话题
        </h2>
        <p className="text-sm text-foreground-500 text-center mb-10 md:mb-14 max-w-lg mx-auto">
          吃瓜群众正在热议的话题标签，点击加入讨论
        </p>
        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic, idx) => (
            <div
              key={idx}
              className={`flex items-center gap-2 px-4 py-2.5 rounded-full ${topic.color} cursor-pointer hover:scale-105 transition-transform duration-200`}
            >
              <span className="text-sm font-medium whitespace-nowrap">{topic.label}</span>
              <span className="text-xs opacity-75 whitespace-nowrap">{topic.heat}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}